<section id="profile-info">
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="form-group mb-2">
                <div class="card">
                    <div class="card-header">
                        <h2>Success Stories</h2>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-3">
                                <small>Name</small>
                                <input class="form-control" [(ngModel)]="name"/>
                            </div>
                            <div class="col-md-3">
                                <small>Rating</small>
                                <div class="rating-picker">
                                    <i *ngFor="let star of ratingStars"
                                       class="fas fa-star cursor-pointer"
                                       [class.text-warning]="rating >= star"
                                       [class.text-muted]="rating < star"
                                       (click)="setRating(star)"></i>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <small>Photo</small>
                                <input class="form-control" type="file" accept="image/*"
                                       (change)="onPhotoSelected($event)">
                                <small *ngIf="uploadingPhoto">Uploading...</small>
                                <img *ngIf="photoPreviewUrl" [src]="photoPreviewUrl"
                                     class="img-fluid rounded mt-1" style="max-height: 60px" alt="Photo preview"/>
                            </div>
                            <div class="col-md-3">
                                <small>Quote</small>
                                <textarea class="form-control" rows="1" [(ngModel)]="quote"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-primary pull-right" rippleEffect
                                (click)="addDetail()" [disabled]="submitting">
                            <span class="font-weight-bold">Add</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="success-stories-grid row" *ngIf="successStories && successStories.length > 0; else noDataToShowWeb">
                <div class="col-lg-3 col-md-6 col-12 mb-2" *ngFor="let story of successStories">
                    <div class="success-story-card">
                        <i class="fas fa-trash font-small-3 text-danger cursor-pointer delete-icon"
                           (click)="delete(story.id)"></i>
                        <div class="stars mb-1">
                            <i *ngFor="let star of ratingStars"
                               class="fas fa-star"
                               [class.text-warning]="story?.rating >= star"
                               [class.text-muted]="!(story?.rating >= star)"></i>
                        </div>
                        <p class="quote">{{story?.quote}}</p>
                        <div class="d-flex align-items-center mt-1">
                            <img *ngIf="story?.photo_file?.url" [src]="story.photo_file.url"
                                 class="avatar rounded-circle" alt="Photo"/>
                            <div *ngIf="!story?.photo_file?.url" class="avatar avatar-placeholder rounded-circle"></div>
                            <h6 class="mb-0 ml-1 font-weight-bold">{{story?.name}}</h6>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #noDataToShowWeb>
                <div class="card">
                    <div class="card-body">
                        <h6 class="text-center mt-1 mb-1">No data to show</h6>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</section>
